
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/member-events",
      function () {
        return require("private-next-pages/member-events.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/member-events"])
      });
    }
  